// @generated by protoc-gen-es-ns v0.0.0 with parameter "target=ts"
// @generated from file web/public/image.proto (package web.public, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message web.public.Image
 */
export class Image extends Message<Image> {
  /**
   * @generated from field: string url = 1;
   */
  url = "";

  /**
   * @generated from field: uint32 width = 2;
   */
  width = 0;

  /**
   * @generated from field: uint32 height = 3;
   */
  height = 0;

  /**
   * @generated from field: web.public.Image.Type type = 4;
   */
  type = Image.Type.UNKNOWN;

  constructor(data?: PartialMessage<Image>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.Image";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "width", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 3, name: "height", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "type", kind: "enum", T: proto3.getEnumType(Image.Type) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Image {
    return new Image().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Image {
    return new Image().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Image {
    return new Image().fromJsonString(jsonString, options);
  }

  static equals(a: Image | PlainMessage<Image> | undefined, b: Image | PlainMessage<Image> | undefined): boolean {
    return proto3.util.equals(Image, a, b);
  }

  static _enums: {
    Type: typeof Image.Type,
  };
}

export namespace Image {
  /**
   * @generated from enum web.public.Image.Type
   */
  export enum Type {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: THUMBNAIL = 1;
     */
    THUMBNAIL = 1,

    /**
     * @generated from enum value: ICON = 2;
     */
    ICON = 2,

    /**
     * @generated from enum value: CARROUSEL = 3;
     */
    CARROUSEL = 3,
  }
  // Retrieve enum metadata with: proto3.getEnumType(Image.Type)
  proto3.util.setEnumType(Image.Type, "web.public.Image.Type", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "THUMBNAIL" },
    { no: 2, name: "ICON" },
    { no: 3, name: "CARROUSEL" },
  ]);
}

